<template>
    <div class="rawdata">
    <pre>
      {{ config }}
    </pre>
    </div>
</template>

<script>
    export default {
        name: 'rawdata',
        props: ['config'],
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// RawData.vue?f6f9104c